import React from 'react'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import * as UIcons from '@iconscout/react-unicons'
import Btn from 'components/Btn'
import StatusPill from '../../shared/StatusPill'
import ActionsMenu from '../../shared/ActionsMenu'

export default withTranslation()(function RoleHeaderCard({ t, role, branchName, usersAssigned, onEdit, onDuplicate, onToggleStatus }) {
  const isActive = (role.status ?? 'active') !== 'inactive'

  const menuActions = [
    { key: 'duplicate', icon: UIcons.UilCopy, label: t('settings.role_management.duplicate_role'), onClick: onDuplicate },
    {
      key: 'toggle-status',
      icon: UIcons.UilBan,
      label: t(isActive ? 'settings.role_management.deactivate' : 'settings.role_management.enable'),
      danger: isActive,
      onClick: onToggleStatus
    }
  ]

  return (
    <div className="w-full bg-white rounded-2xl border border-border-lines shadow-sm p-6 mb-5">
      <div className="flex items-start justify-between gap-4 pb-4 border-b border-border-lines">
        <div>
          <h1 className="text-2xl font-semibold text-dark-blue">{role.display_name ?? role.name}</h1>
          {role.description && <p className="text-xs text-secondary mt-1">{role.description}</p>}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <StatusPill active={isActive} inactiveText={t('settings.role_management.filters.inactive')} />

          <Btn
            content={() => <span className="flex items-center gap-1.5"><UIcons.UilEditAlt size={14} /> {t('misc.edit')}</span>}
            className="text-dark-blue bg-white border border-border-lines rounded-full h-9 px-4 font-medium"
            click={onEdit}
          />

          <ActionsMenu items={menuActions} />
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4">
        <div>
          <p className="text-xs font-semibold text-secondary mb-1">{t('settings.role_management.detail.status')}</p>
          <p className={`text-base ${isActive ? 'text-success' : 'text-danger'}`}>
            {isActive ? t('settings.role_management.filters.active') : t('settings.role_management.filters.inactive')}
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold text-secondary mb-1">{t('settings.role_management.detail.branch_access')}</p>
          <p className="text-base text-dark-blue">{branchName ?? t('settings.role_management.form.branch_access.placeholder')}</p>
        </div>
        <div>
          <p className="text-xs font-semibold text-secondary mb-1">{t('settings.role_management.detail.users_assigned')}</p>
          <p className="text-base text-dark-blue">{usersAssigned}</p>
        </div>
        <div>
          <p className="text-xs font-semibold text-secondary mb-1">{t('settings.role_management.detail.last_updated')}</p>
          <p className="text-base text-dark-blue">{role.updated_at ? dayjs(role.updated_at).format('MMM D, YYYY h:mm A') : '—'}</p>
        </div>
      </div>
    </div>
  )
})
